import React, { useRef } from "react";
import ApertureMark from "./ApertureMark";
import useIntroChoreography from "../../hooks/useIntroChoreography";
import { SITE, UI } from "../../content/site";
import { useLanguage } from "../../i18n/LanguageContext";

// A tall, sticky black stage. Scrolling composes the mark stroke-by-stroke, then
// the wordmark and thesis rise. The hook writes progress; the stylesheet paints.
// In Japanese the thesis also exists as a vertical column set (tategaki) that
// the stylesheet shows on wide screens in place of the horizontal line.
export default function Intro() {
  const ref = useRef(null);
  useIntroChoreography(ref);
  const { lang, t } = useLanguage();

  return (
    <section
      id="intro"
      ref={ref}
      className="dp-intro"
      data-screen-label="Intro"
      aria-labelledby="hero-h"
    >
      <div className="dp-intro__stage">
        <div className="dp-intro__logo-wrap">
          <ApertureMark className="dp-intro__logo" decorative />
        </div>
        <div className="dp-intro__title">
          <h1 id="hero-h" className="dp-intro__wordmark">
            Digital Philosophy
          </h1>
          <p className="dp-intro__thesis">{t(SITE.tagline)}</p>
        </div>
        {lang === "ja" && (
          <p className="dp-intro__vthesis" aria-hidden="true">
            {SITE.taglineColumnsJa.map((column, i) => (
              <React.Fragment key={column}>
                {i > 0 && <br />}
                {column}
              </React.Fragment>
            ))}
          </p>
        )}
        <div className="dp-intro__cue" aria-hidden="true">
          <span className="dp-eyebrow">{t(UI.scroll)}</span>
          <span className="dp-intro__cue-line" />
        </div>
      </div>
    </section>
  );
}
